import React, { useEffect, useState, startTransition } from "react";
import { getImplCustomers } from "./Network_Calls";
import { useParams, Link, useNavigate } from "react-router-dom";
import classes from "./Search.module.css";
import Navbar from "../Navbar/Navbar";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

const MostViewed = () => {
  const { implname, implId } = useParams();
  const [spinner, setSpinner] = useState(false);

  const navigate = useNavigate();

  const [most_viewed, setmost_viewd] = useState([]);
  useEffect(() => {
    (async function () {
      startTransition(() => {
        setmost_viewd(null);
      });
      setSpinner(true);
      const result = await getImplCustomers(implname);
      if (result.data.msg === "Generated") {
        const views = result.data.views.slice(0, 25);
        startTransition(() => {
          setmost_viewd([...views]);
          setSpinner(false);
        });
      }
    })();
  }, []);

  console.log(most_viewed);

  return (
    <div>
      <Navbar />
      <div style={{ padding: "30px" }}>
        <Button
          onClick={() => navigate(-1)}
          variant="contained"
        >
          Go back
        </Button>
      </div>
      {spinner ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {" "}
            Please wait ....
            <CircularProgress />
          </div>
        </Box>
      ) : (
        <>
          {" "}
          {most_viewed.length !== 0 ? (
            <div>
              <div>
                <h5 className={classes.mostviewed_banner}>Most Viewed</h5>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "700px", marginTop: "20px" }}>
                  {most_viewed.map((el, ind) => (
                    <div
                      className={classes.mostviewed_item}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      key={ind}
                    >
                      <Link
                        style={{
                          color: "#FF762B",
                          fontSize: "16px",
                          fontWeight: "normal",
                        }}
                        // target="__blanck"
                        to={`/user/findContact/${implId}/${el.external_id}?name=${el.username}`}
                      >
                        {el.username !== null ? (
                          <p>
                            {el.username.length < 20
                              ? el.username
                              : el.username.slice(0, 20) + ".." || "None"}
                          </p>
                        ) : (
                          <p>None</p>
                        )}
                      </Link>

                      <h4 style={{ textAlign: "end" }}>
                        {el.customer_views}{" "}
                        <span style={{ textAlign: "end" }}>
                          {el.customer_views === 1 ? "view" : "views"}{" "}
                        </span>
                      </h4>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
};

export default MostViewed;
